function formatAttribute(val) {
  if (val == null || typeof val == "undefined") return "";
  return val.replaceAll("[-split1-]", ":").replaceAll("[-split2-]", '"');
}

function unFormatAttribute(val) {
  if (val == null || typeof val == "undefined") return "";
  return val.replaceAll(":", "[-split1-]").replaceAll('"', "[-split2-]");
}

const GIFT_PROMOTION_B2C_MINIMUM_CART_CENTS = 300000;
const GIFT_PROMOTION_B2B_MINIMUM_CART_CENTS = 350000;

function getGiftPromotionMinimumCartCents() {
  return String(window.isB2C) === "true"
    ? GIFT_PROMOTION_B2C_MINIMUM_CART_CENTS
    : GIFT_PROMOTION_B2B_MINIMUM_CART_CENTS;
}

function isGiftPromotionRuleEnabledForCustomer(rule) {
  if (!rule) {
    return false;
  }

  const customerTypeKey = String(window.isB2C) === "true" ? "B2C" : "B2B";
  return rule[customerTypeKey] === true || String(rule[customerTypeKey]) === "true";
}

function wait(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

async function requestCartResource(url, options = {}, responseType = "json") {
  const maxRetries = 2;
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    const result = await fetch(url, options);
    if (result.status !== 429 || attempt === maxRetries) {
      if (responseType === "response") {
        return result;
      }
      if (responseType === "text") {
        return result.text();
      }
      try {
        return await result.json();
      } catch (error) {
        return {
          status: result.status,
          statusText: result.statusText,
          description: result.status === 429
            ? "Too many cart requests. Please wait a moment and try again."
            : "Unable to read cart response.",
        };
      }
    }

    await wait((attempt + 1) * 800);
  }
}

function getGiftPromotionRules() {
  let data = window.giftPromotionRules || {};
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch (error) {
      console.log(error);
      data = {};
    }
  }

  if (!data.giftPackages || !Array.isArray(data.rules)) {
    return null;
  }

  return data;
}

function getGiftPromotionRule(variantId) {
  const promotionRules = getGiftPromotionRules();
  if (!promotionRules) {
    return null;
  }

  return promotionRules.rules.find((rule) => {
    return (
      String(rule.variantId) === String(variantId) &&
      isGiftPromotionRuleEnabledForCustomer(rule)
    );
  });
}

function getCartPromotionSubtotal(cart) {
  if (!cart || !Array.isArray(cart.items)) {
    return 0;
  }

  return cart.items.reduce((subtotal, item) => {
    if (item?.properties?._gift_promotion_item === "true") {
      return subtotal;
    }

    return subtotal + (parseInt(item.original_line_price, 10) || 0);
  }, 0);
}

function getCartPromotionParentQuantity(cart, variantId) {
  if (!cart || !Array.isArray(cart.items)) {
    return 0;
  }

  return cart.items.reduce((total, item) => {
    if (item?.properties?._gift_promotion_item === "true") {
      return total;
    }

    if (String(item.variant_id) !== String(variantId)) {
      return total;
    }

    return total + (parseInt(item.quantity, 10) || 0);
  }, 0);
}

function getCartGiftPromotionQuantity(cart, parentVariantId, giftVariantId, packageName) {
  if (!cart || !Array.isArray(cart.items)) {
    return 0;
  }

  return cart.items.reduce((total, item) => {
    const properties = item?.properties || {};
    if (properties._gift_promotion_item !== "true") {
      return total;
    }

    if (String(properties._gift_promotion_parent_variant_id) !== String(parentVariantId)) {
      return total;
    }

    if (String(properties._gift_promotion_package) !== String(packageName)) {
      return total;
    }

    if (String(item.variant_id) !== String(giftVariantId)) {
      return total;
    }

    return total + (parseInt(item.quantity, 10) || 0);
  }, 0);
}

function getGiftPromotionParentKey(item) {
  const properties = item?.properties || {};
  return String(
    item?.parent_relationship?.parent_key ||
    properties._gift_promotion_parent_key ||
    properties._nested_cart_parent_key ||
    properties._gift_promotion_parent_variant_id ||
    properties._nested_cart_parent_variant_id ||
    ""
  );
}

function getGiftPromotionLineKey(parentItem, packageName, giftVariantId) {
  const parentKey = parentItem?.key || parentItem?.variant_id || "";
  return [
    parentKey,
    parentItem?.variant_id || "",
    packageName,
    giftVariantId,
  ].join("|");
}

function findDesiredGiftLineKey(desiredGifts, item) {
  const properties = item?.properties || {};
  const exactKey = [
    getGiftPromotionParentKey(item),
    properties._gift_promotion_parent_variant_id || properties._nested_cart_parent_variant_id || "",
    properties._gift_promotion_package,
    item.variant_id,
  ].join("|");

  if (desiredGifts[exactKey]) {
    return exactKey;
  }

  const parentVariantId = String(
    properties._gift_promotion_parent_variant_id ||
    properties._nested_cart_parent_variant_id ||
    ""
  );
  const packageName = String(properties._gift_promotion_package || "");
  const giftVariantId = String(item.variant_id || "");

  return Object.keys(desiredGifts).find((key) => {
    const parts = key.split("|");
    return (
      String(parts[1] || "") === parentVariantId &&
      String(parts[2] || "") === packageName &&
      String(parts[3] || "") === giftVariantId
    );
  });
}

async function syncGiftPromotionItems(cart) {
  const promotionRules = getGiftPromotionRules();
  if (!promotionRules) {
    return false;
  }

  cart = cart || await getCart();
  const isQualified = getCartPromotionSubtotal(cart) >= getGiftPromotionMinimumCartCents();

  const desiredGifts = {};
  if (isQualified) {
    cart.items.forEach((item) => {
      const properties = item?.properties || {};
      if (properties._gift_promotion_item === "true") {
        return;
      }

      const promotionRule = getGiftPromotionRule(item.variant_id);
      if (!promotionRule) {
        return;
      }

      const giftPackage = promotionRules.giftPackages[promotionRule.giftPackage];
      if (!Array.isArray(giftPackage)) {
        return;
      }

      giftPackage.forEach((gift) => {
        const giftQtyNumber = parseInt(gift.quantity, 10) || 1;
        const key = getGiftPromotionLineKey(item, promotionRule.giftPackage, gift.variantId);

        if (!desiredGifts[key]) {
          desiredGifts[key] = {
            parentItem: item,
            packageName: promotionRule.giftPackage,
            gift,
            quantity: 0,
          };
        }

        desiredGifts[key].quantity += (parseInt(item.quantity, 10) || 0) * giftQtyNumber;
      });
    });
  }

  const desiredRemainingQty = {};
  Object.keys(desiredGifts).forEach((key) => {
    desiredRemainingQty[key] = desiredGifts[key].quantity;
  });
  const updates = {};
  const addItems = [];
  const assignedGiftLines = {};

  cart.items.forEach((item) => {
    const properties = item?.properties || {};
    if (properties._gift_promotion_item !== "true") {
      return;
    }

    const key = findDesiredGiftLineKey(desiredGifts, item);
    const desiredQty = key ? desiredRemainingQty[key] || 0 : 0;
    const itemQty = parseInt(item.quantity, 10) || 0;
    const keepQty = key && !assignedGiftLines[key] ? desiredQty : 0;

    if (key) {
      assignedGiftLines[key] = true;
      desiredRemainingQty[key] = Math.max(desiredQty - keepQty, 0);
    }
    if (keepQty !== itemQty) {
      updates[item.key] = keepQty;
    }
  });

  Object.keys(desiredGifts).forEach((key) => {
    const desiredGift = desiredGifts[key];
    const missingGiftQty = desiredRemainingQty[key] || 0;

    if (missingGiftQty <= 0) {
      return;
    }

    const parentVariantId = desiredGift.parentItem.variant_id;
    const parentKey = desiredGift.parentItem.key || "";
    const parentProperties = desiredGift.parentItem.properties || {};
    addItems.push({
      id: String(desiredGift.gift.variantId),
      quantity: missingGiftQty,
      properties: {
        ...parentProperties,
        _depth: "",
        _width: "",
        _nested_cart_child: "true",
        _nested_cart_parent_key: String(parentKey),
        _nested_cart_parent_variant_id: String(parentVariantId),
        _gift_promotion_item: "true",
        _gift_promotion_package: desiredGift.packageName,
        _gift_promotion_parent_key: String(parentKey),
        _gift_promotion_parent_variant_id: String(parentVariantId),
        _default_product_id: String(desiredGift.gift.productId),
        _default_variant_id: String(desiredGift.gift.variantId),
      },
    });
  });

  let hasChanged = false;
  if (Object.keys(updates).length > 0) {
    await updateCartItems({ updates });
    await wait(300);
    hasChanged = true;
  }

  if (addItems.length > 0) {
    const response = await addItem({ items: addItems });
    hasChanged = hasChanged || (response && response.status === 200);
  }

  return hasChanged;
}

async function syncGiftPromotionItemsAndGetCart(cart) {
  if (typeof syncGiftPromotionItems != "function") {
    return cart || await getCart();
  }

  await wait(300);
  const currentCart = await getCart();
  const hasChanged = await syncGiftPromotionItems(currentCart);
  if (hasChanged) {
    await wait(300);
    return getCart();
  }

  return currentCart || cart || await getCart();
}

async function canApplyGiftPromotion(productPrice, quantity) {
  productPrice = parseInt(productPrice, 10) || 0;
  if (productPrice <= 0) {
    return {
      cart: null,
      isQualified: false,
    };
  }

  const cart = await getCart();
  const cartSubtotal = getCartPromotionSubtotal(cart);

  return {
    cart,
    isQualified:
      cartSubtotal + productPrice * quantity >= getGiftPromotionMinimumCartCents(),
  };
}

async function addGiftPromotionItems({
  addItems,
  variantId,
  quantity,
  productPrice,
  shopifyProperties,
}) {
  const promotionRules = getGiftPromotionRules();
  const promotionRule = getGiftPromotionRule(variantId);

  if (!promotionRules || !promotionRule) {
    return;
  }

  const giftPackage = promotionRules.giftPackages[promotionRule.giftPackage];
  if (!Array.isArray(giftPackage) || giftPackage.length === 0) {
    return;
  }

  const productQtyNumber = parseInt(quantity, 10);
  if (isNaN(productQtyNumber) || productQtyNumber < 1) {
    return;
  }

  const qualification = await canApplyGiftPromotion(productPrice, productQtyNumber);
  if (!qualification.isQualified) {
    return;
  }

  const parentQtyNumber =
    getCartPromotionParentQuantity(qualification.cart, variantId) +
    productQtyNumber;

  const nestedCartChildBaseProperties = {
    ...shopifyProperties,
    _depth: "",
    _width: "",
    _nested_cart_child: "true",
    _nested_cart_parent_key: "",
    _nested_cart_parent_variant_id: String(variantId),
    _gift_promotion_item: "true",
    _gift_promotion_package: promotionRule.giftPackage,
    _gift_promotion_parent_key: "",
    _gift_promotion_parent_variant_id: String(variantId),
  };

  giftPackage.forEach((gift) => {
    const giftQtyNumber = parseInt(gift.quantity, 10) || 1;
    const desiredGiftQty = parentQtyNumber * giftQtyNumber;
    const currentGiftQty = getCartGiftPromotionQuantity(
      qualification.cart,
      variantId,
      gift.variantId,
      promotionRule.giftPackage,
    );
    const missingGiftQty = desiredGiftQty - currentGiftQty;

    if (missingGiftQty <= 0) {
      return;
    }

    addItems.push({
      id: String(gift.variantId),
      quantity: missingGiftQty,
      parent_id: String(variantId),
      properties: {
        ...nestedCartChildBaseProperties,
        _default_product_id: String(gift.productId),
        _default_variant_id: String(gift.variantId),
      },
    });
  });
}

/*
 productid:variantid:product_handle:width:model:collection_handle:collection_doorstyle:is_aos
*/
async function addSampleDoor(_obj) {
  Show_Loading();
  //console.log($(_obj));
  var attributes = $(_obj).data("obj").split(":");

  if (attributes[7] == "") {
    attributes[7] = "false";
  }

  //console.log(attributes);

  var productid = formatAttribute(attributes[0]);
  var variantid = formatAttribute(attributes[1]);
  var product_handle = formatAttribute(attributes[2]);
  var collection_handle = formatAttribute(attributes[5]);

  var validData = await VaidAdd2Cart(
    productid,
    variantid,
    product_handle,
    collection_handle,
  );

  if (validData.success) {
    var productModel = attributes[4];
    var productQty = 1;
    var shopifyProperties = {};

    shopifyProperties._ideal_collection_handle = formatAttribute(attributes[5]);
    if (
      formatAttribute(attributes[3]) != "" &&
      !isNaN(parseInt(formatAttribute(attributes[3]))) &&
      parseInt(formatAttribute(attributes[3])) > 0
    ) {
      shopifyProperties._width = formatAttribute(attributes[3]);
    }
    shopifyProperties._default_product_id = attributes[0];
    shopifyProperties._default_variant_id = attributes[1];
    shopifyProperties._ideal_product_program = "Assembled";
    shopifyProperties._ideal_doorstyle = formatAttribute(attributes[6]);
    shopifyProperties._depth = "";
    shopifyProperties._isAos = "false";
    if (custNum == "C004490" || custNum == "C006077" || custNum == "C006935") {
      shopifyProperties._custnum = custNum;
    }
    shopifyProperties._freight_rule = formatAttribute(freight_rule);

    var addItemsToShopify = {};
    var addItems = [];
    var addItemsObject = {
      id: variantid,
      quantity: productQty,
      properties: shopifyProperties,
    };
    addItems.push(addItemsObject);
    addItemsToShopify.items = addItems;
    var addingMsg = "Adding Qty " + productQty + " of " + productModel + ".";
    Show_Loading(addingMsg);
    var addCarts = await addItem(addItemsToShopify)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(async (response) => {
        if (typeof SetInCartItemState == "function") await SetInCartItemState();
        if (typeof syncGiftPromotionItemsAndGetCart == "function") {
          await syncGiftPromotionItemsAndGetCart(response);
        }
        await UpdateMiniCart();

        Shopify.analytics.publish("send_custom_event", {
          name: "add_to_cart",
          data: {
            cust_num: custNum,
            model: productModel,
            door_style: shopifyProperties._ideal_doorstyle,
            qty: productQty,
            referrer: document.referrer ?? "",
            date: new Date().toString(),
          },
        });

        Hide_Loading();
      })
      .catch((error) => {
        Hide_Loading();
        console.log(error);
      });
  } else {
    if (validData.errorMessage != null) {
      $.colorbox({
        width: "30%",
        height: "auto",
        overlayClose: false,
        href: false,
        html:
          '<div style="padding:10px;color:red;">' +
          validData.errorMessage +
          "</div>",
      });
    } else {
      $.colorbox({
        width: "50%",
        height: "auto",
        overlayClose: false,
        href: false,
        html: getProHtml(
          validData.cartDoorStyleGroup,
          validData.currentDoorStyleGroup,
        ),
      });
    }
    Hide_Loading();
  }
}

//*
// obj: productid:variantid:product_handle:width:model:collection_handle:collection_doorstyle:is_aos
//
// */
async function AddToCart(
  obj,
  successFun,
  errorFun,
  selectedDepth = "",
  add_to_cart_type = "default",
) {
  var $o = $(obj);

  var $i = $o.closest(".js-product-item");
  if (add_to_cart_type === "product") {
    $i = $o.closest(".js-product-detail-page");
  }

  var attributes = $o.data("obj").split(":");
  if (attributes[7] == "") {
    attributes[7] = "false";
  }
  //const ttt= await getCart();
  //console.log(ttt);

  //console.log(attributes);

  var productid = "";
  var variantid = "";
  var _default_variant_id = 0;
  var productCustomDepthValue = selectedDepth;

  if ($i.closest(".js-product-item-table-1").length > 0) {
    const $tr = $o.closest("tr");
    if ($tr.find("select.js-select-custom-depth:visible").length > 0) {
      productCustomDepthValue = $tr.find("select.js-select-custom-depth").val();
    } else if ($tr.find("select.js-select-custom-depth:hidden").length > 0) {
      productCustomDepthValue = $tr
        .find("select.js-select-custom-depth option[default]")
        .attr("value");
    }
  }

  /* 
   if($i.find('select.select-hinge').length>0){
     var data =  $i.find('select.select-hinge option:selected').data('obj');
     if(data.endsWith(",")){
       data = data.substring(0,data.length-1);
     }

     if($i.find('select.select-depth').length>0){
       var depthItems = data.split(',');
       var selectedDepth = $i.find('select.select-depth').val();
       productCustomDepthValue = selectedDepth;
       var intDepth = selectedDepth.split(':')[0];
       var currentDepth = depthItems.filter(i=>i.startsWith(intDepth+':'));

       if(currentDepth.length >0){
         currentDepth = currentDepth[0];
         productid = currentDepth.split(':')[1];
         variantid = currentDepth.split(':')[2];
     }
      var defaultDepth =  $i.find('select.select-depth option[data-default="true"]').val();
      var intDepthDepth = defaultDepth.split(':')[0];
      defaultDepth = depthItems.filter(i=>i.startsWith(intDepthDepth +':'));
      if(defaultDepth.length >0){
         defaultDepth = defaultDepth[0];
         _default_variant_id = defaultDepth.split(':')[2];
      }

     }else{
       productid = data.split(':')[1];
       variantid = data.split(':')[2];
       _default_variant_id =data.split(':')[2];
     }

   } else if($i.find('select.select-depth').length>0){
     productCustomDepthValue = $i.find('select.select-depth').val();
     var data = $i.find('select.select-depth option:selected').data('obj');

     if(data.length>0 && data.split(':').length==3)
     {
       productid = data.split(':')[0];
       variantid = data.split(':')[1];
     }
     var defaultData = $i.find('select.select-depth option[data-default="true"]').data('obj');
     if(defaultData.length>0 && defaultData.split(':').length==3){
       _default_variant_id = defaultData.split(':')[1];
     }


   }else{
     productid = formatAttribute(attributes[0]);
     variantid = formatAttribute(attributes[1]);
     _default_variant_id = formatAttribute(attributes[1]);
   }
  */
  var _isAos = false;
  if ($i.find("select.select-hinge").length > 0) {
    var data = $i.find("select.select-hinge option:selected").data("obj");
    var dataArray = data.split(":");
    productid = dataArray[0];
    variantid = dataArray[1];
    _default_variant_id = dataArray[1];
  } else {
    _isAos = formatAttribute(attributes[7]) === "true";
    productid = formatAttribute(attributes[0]);
    variantid = formatAttribute(attributes[1]);
    _default_variant_id = formatAttribute(attributes[1]);
  }

  if (variantid.length == 0) {
    alert("Not find variant id.");
    if (errorFun) errorFun();
    return;
  }

  Show_Loading();

  const product_handle = formatAttribute(attributes[2]);
  const collection_handle = formatAttribute(attributes[5]);
  var validData = await VaidAdd2Cart(
    productid,
    variantid,
    product_handle,
    collection_handle,
  );

  if (validData.success) {
    //productid:variantid:product_handle:width:model:collection_handle:collection_doorstyle
    var productModel = attributes[4];
    var productQty = $i.find(".js-add-to-cart-quantity").val();
    if (add_to_cart_type === "product_pop_up_detail") {
      productQty = $(".js-product-pop-quantity").val();
    }

    if (add_to_cart_type === "arousel_item") {
      productQty = 1;
    }

    if (isNaN(parseInt(productQty)) || parseInt(productQty) < 1) {
      Hide_Loading();
      alert("Please enter valid quantity.");
      if (errorFun) errorFun();
      return;
    }

    var shopifyProperties = {};
    shopifyProperties._ideal_collection_handle = formatAttribute(attributes[5]);

    if (
      formatAttribute(attributes[3]) != "" &&
      !isNaN(parseInt(formatAttribute(attributes[3]))) &&
      parseInt(formatAttribute(attributes[3])) > 0
    ) {
      shopifyProperties._width = formatAttribute(attributes[3]);
    }
    shopifyProperties._ideal_doorstyle = formatAttribute(attributes[6]);
    shopifyProperties._ideal_product_program = "Assembled";
    shopifyProperties._depth = productCustomDepthValue;
    shopifyProperties._default_product_id = productid;
    shopifyProperties._default_variant_id = _default_variant_id;
    //console.log(_isAos)
    if (_isAos) {
      shopifyProperties._isAos = "true";
    } else {
      shopifyProperties._isAos = "false";
    }

    if (attributes.length == 6) {
      shopifyProperties._ideal_collection_handle = formatAttribute(
        attributes[5],
      );
      shopifyProperties._ideal_doorstyle = formatAttribute(attributes[6]);
    }
    if (custNum == "C004490" || custNum == "C006077" || custNum == "C006935") {
      shopifyProperties._custnum = custNum;
    }
    shopifyProperties._freight_rule = formatAttribute(freight_rule);
    /*
     if(productCustomDepthValue){
        shopifyProperties.depth = productCustomDepthValue;
      }
      console.log(shopifyProperties); 
     */

    var addItemsToShopify = {};
    var addItems = [];
    var addItemsObject = {
      id: variantid,
      quantity: productQty,
      properties: shopifyProperties,
    };
    addItems.push(addItemsObject);
    await addGiftPromotionItems({
      addItems,
      variantId: variantid,
      quantity: productQty,
      productPrice: validData.price,
      shopifyProperties,
    });

    addItemsToShopify.items = addItems;
    var addingMsg = "Adding Qty " + productQty + " of " + productModel + ".";
    Show_Loading(addingMsg);
    var addCarts = await addItem(addItemsToShopify)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(async (response) => {
        if (typeof SetInCartItemState == "function") await SetInCartItemState();
        if (typeof syncGiftPromotionItemsAndGetCart == "function") {
          await syncGiftPromotionItemsAndGetCart(response);
        }
        await UpdateMiniCart();

        Shopify.analytics.publish("send_custom_event", {
          name: "add_to_cart",
          data: {
            cust_num: custNum,
            model: productModel,
            door_style: shopifyProperties._ideal_doorstyle,
            qty: productQty,
            referrer: document.referrer ?? "",
            date: new Date().toString(),
          },
        });

        Hide_Loading();
        if (successFun) successFun(addItems);
      })
      .catch((error) => {
        Hide_Loading();
        console.log(error);
        if (errorFun) errorFun();
      });
  } else {
    if (validData.errorMessage != null) {
      $.colorbox({
        width: "30%",
        height: "auto",
        overlayClose: false,
        href: false,
        html:
          '<div style="padding:10px;color:red;">' +
          validData.errorMessage +
          "</div>",
      });
    } else {
      $.colorbox({
        width: "50%",
        height: "auto",
        overlayClose: false,
        href: false,
        html: getProHtml(
          validData.cartDoorStyleGroup,
          validData.currentDoorStyleGroup,
        ),
      });
    }
    Hide_Loading();
    if (errorFun) errorFun();
  }
}

function getProHtml(cartGroup, currentGroup) {
  var _html = `
    <table style="width:100%;">
      <tr>
          <td>
            <br>
          </td>
      </tr>
      <tr>
          <td style="Text-indent:25px;padding:0 25px;">
              <h2>
                You currently have <font style="color:red;">${cartGroup}</font> items in your shopping cart and are trying to purchase <font style="color:red;">${currentGroup}</font> items.  These types of items cannot be combined on the same order.  Please complete your order for all <font style="color:red;">${cartGroup}</font> items before adding other types of items.
              </h2><h2>
              </h2>
          </td>
      </tr>
      <tr>
          <td style="text-align:center;line:40px;line-height:40px;">
            <input type="button" value="Clear The Cart" id="btn_clear" onclick="btn_clear()" style="width:auto;font-weight:bold;">
            <input type="button" value="Save The Cart" id="btn_save" onclick="btn_save()" style="width:auto;font-weight:bold;">
            <input type="button" value="Go To Cart" id="btn_goto" onclick="btn_goto()" style="width:auto;font-weight:bold;">
          </td>
      </tr>
    </table>`;

  return _html;
}

async function UpdateMiniCart() {
  /* 
  let cartForm = new theme.CartForm(document.querySelector('#CartDrawer'));
  cartForm.buildCart();      
  setTimeout(function(){        
    if (parseInt($('#CartDrawer .cart__items').attr('data-count')) > 0) {
      $('#CartDrawer').removeClass('is-empty');
    } else {
      $('#CartDrawer').addClass('is-empty');
    } 
  },900); 
  */

  var _vid = "4";
  for (var i = 0; i < 13; i++) {
    _vid += Math.floor(Math.random() * 10).toString();
  }
  var url = "/?section_id=ic-ajax-minicart-content&variant=" + _vid;
  url += `&rad=${encodeURIComponent(new Date().toString())}`;
  var data = await (await fetch(url)).text();

  $minicart = $(data);
  $("#ajaxminicartcontents #CartDrawer")
    .html($minicart.find("#CartDrawer").html())
    .attr("class", $minicart.find("#CartDrawer").attr("class"));
  if (Shopify.MiniCartEvent.Bind) Shopify.MiniCartEvent.Bind();
  await syncBundleLineImages(document.getElementById("ajaxminicartcontents"));

  ChangeCartIcon();
  document.dispatchEvent(
    new CustomEvent("ajaxProduct:added", {
      detail: { data: data, type: "add-to-cart" },
    }),
  );

  /* 
    let cartForm = new theme.CartForm(document.querySelector('#CartDrawer'));
    cartForm.buildCart();
  
  
    $('html').addClass('js-drawer-open').addClass('lock-scroll');
    const x = new theme.Drawers('CartDrawer', 'cart');
    x.isOpen = true; */
  /* if ($minicart.find('.js-cart-menu').length > 0) {
    $('#minicartitemquantity').html($minicart.find('.js-cart-menu').attr('data-cart-count'));
    $('#ajaxminicartcontents').html($minicart.html());
    if (Shopify.MiniCartEvent.Bind) Shopify.MiniCartEvent.Bind();
    $("#fat-btnminicart").addClass("open");
    $("#fat-btnminicart").attr("aria-expanded", "true");
  } else {
    $('#minicartitemquantity').html('&nbsp;');
    $('#ajaxminicartcontents').empty();
    $("#fat-btnminicart").removeClass("open");
    $("#fat-btnminicart").attr("aria-expanded", "false");
  } */
}

function ChangeCartIcon() {
  if ($("#ajaxminicartcontents #CartDrawer").hasClass("is-empty")) {
    var bubbles = document.querySelectorAll(".cart-link__bubble");
    if (bubbles.length) {
      bubbles.forEach((b) => {
        b.classList.remove("cart-link__bubble--visible");
      });
    }
  } else {
    var bubbles = document.querySelectorAll(".cart-link__bubble");
    if (bubbles.length) {
      bubbles.forEach((b) => {
        b.classList.add("cart-link__bubble--visible");
      });
    }
  }
}

async function clearCart() {
  const result = await fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
  });
  return result.json();
}

async function btn_clear() {
  Show_Loading("Loading...");
  var clear = await clearCart();
  window.location.href = location.href;
  parent.$.colorbox.close();
  Hide_Loading();
}

function btn_save() {
  CloseCurrentColorBox();
  window.location.href = "/pages/SaveQuote";
}

function btn_goto() {
  CloseCurrentColorBox();
  window.location.href = "/cart";
}

function CloseCurrentColorBox() {
  parent.$.colorbox.close();
}

async function addItem(data = {}) {
  return requestCartResource(
    "/cart/add.js",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    },
    "response",
  );
}

async function updateCartItems(data = {}) {
  return requestCartResource("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  });
}

async function getCart() {
  return requestCartResource("/cart.js");
}

async function syncBundleLineImages(root = document) {
  const images = root.querySelectorAll?.(
    ".js-bundle-line-image[data-bundle-line-key]",
  );
  if (!images || images.length === 0) return;

  const cart = await getCart();
  const bundleImageMap = new Map();
  (cart.items || []).forEach((item) => {
    const signature = item?.properties?.__bundleSignature;
    const imageUrl = item?.image || item?.featured_image?.url;
    if (!signature || !imageUrl || !item?.key) return;
    bundleImageMap.set(item.key, {
      imageUrl,
      title: item.title || "",
    });
  });

  images.forEach((image) => {
    const bundle = bundleImageMap.get(image.dataset.bundleLineKey);
    if (!bundle) return;
    image.src = bundle.imageUrl;
    if (bundle.title) {
      image.alt = bundle.title;
    }
  });
}

async function VaidAdd2Cart(productId, variantId, product_handle, handle) {
  const _h = handle;
  var url =
    "/?section_id=ic-ajax-add-to-cart-valid&product=" +
    productId +
    "&variant=" +
    variantId +
    "&product_handle_k=" +
    encodeURIComponent(product_handle) +
    "&handle=" +
    encodeURIComponent(_h);
  url += `&rad=${new Date().toString()}`;
  var data = await (await fetch(url)).text();
  var html = $(data).html();
  data = JSON.parse(JSON.parse(html));
  return data;
}

function openQuickViewWindow(
  product_id,
  variant_id,
  prodcut_handle,
  collection_handle,
  user_login_valid,
  is_express,
) {
  var obj = `<div class="modal fade product-modal-wrap"  tabindex="-1" role="dialog" >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">X</button>
            </div>
            <div class="modal-body"><div class="product-spinner"></div></div>
          </div>
        </div>
      </div>
      `;
  obj = $(obj);
  obj
    .on("show.bs.modal", async function () {
      var _url = `/?section_id=ic-ajax-product-detail&variant=${variant_id}&product=${product_id}&ph=${encodeURIComponent(formatAttribute(prodcut_handle))}&ch=${encodeURIComponent(formatAttribute(collection_handle))}`;
      var data = await (await fetch(_url)).text();
      $(this).find(".modal-body").html(data);
      addProductPopDetailsEvent(user_login_valid, is_express);
    })
    .on("hidden.bs.modal", function () {
      $(this).remove();
    })
    .modal("show");
}

function addProductPopDetailsEvent(user_login_valid, is_express) {
  $(".product-modal-wrap .js-product-add-to-cart-button").each(function () {
    $(this).data("obj", $(this).attr("data-value")).removeAttr("data-value");
  });
  $('.product-modal-wrap [data-toggle="popover"]')
    .popover()
    .mouseover(function (e) {
      $(".product-modal-wrap .side-popover[aria-describedby]")
        .not(this)
        .popover("hide");
      if ($(this).hasClass("side-popover")) {
        if ($("#" + $(this).attr("aria-describedby")).length == 0) {
          //console.log('show');
          $(this).popover("show");
        }
      }
    });

  var change_pop_imager_carousel = function (images) {
    var carousel = $(
      ".js-product-pop-carousel",
      "#shopify-section-ic-ajax-product-detail",
    );

    if (images.length > 0) {
      carousel.show();
      var carousel_id = carousel.attr("id");
      var smallImg = carousel.find(".carousel-indicators");
      var bigImg = carousel.find(".carousel-inner");

      smallImg.find("li").remove();
      bigImg.find(".item").remove();

      if (images.length <= 1) {
        bigImg.find(".left").hide();
        bigImg.find(".right").hide();
      } else {
        bigImg.find(".left").show();
        bigImg.find(".right").show();
      }

      for (var i = 0; i < images.length; i++) {
        var li = $(`<li data-target="#${carousel_id}" data-slide-to="${i}" />`);
        li.append(
          `<img class="img-responsive center-block" src="${images[i]}" alt="image${i}" width="80" height="80"  />`,
        );
        if (i == 0) {
          li.addClass("active");
        }
        li.appendTo(smallImg);

        var item = $(`<div class="item" />`);
        if (i == 0) {
          item.addClass("active");
        }
        item.append(
          `<img class="img-responsive center-block" src="${images[i]}" alt="image${i}" width="860" height="730"  />`,
        );
        item.appendTo(bigImg);
      }

      //carousel.carousel();
    } else {
      carousel.hide();
    }
  };

  var getDimensions = function (_width, _depth, _height) {
    var _dimensions = "";
    if ((_width ?? "").length > 0) {
      _dimensions += `${_width}" Width`;
    }
    if ((_depth ?? "").length > 0) {
      if (_dimensions.length > 0) _dimensions += " x ";
      _dimensions += `${_depth}" Depth`;
    }
    if ((_height ?? "").length > 0) {
      if (_dimensions.length > 0) _dimensions += " x ";
      _dimensions += `${_height}" Height`;
    }
    return _dimensions;
  };

  var change_pop_price = function (_price, _discountprice) {
    if (user_login_valid) {
      _price = parseFloat(_price) / 100.0;
      _discountprice = parseFloat(_discountprice) / 100.0;

      let price_html = "";
      if (_price == _discountprice) {
        price_html = `<span>${Ideal.formatMoney(_price, Ideal.money_format)}</span>`;
      } else {
        price_html = `<del>${Ideal.formatMoney(_price, Ideal.money_format)}</del>&nbsp;&nbsp;
                    <span class="discountprice">
                    ${Ideal.formatMoney(_discountprice, Ideal.money_format)}
                    </span>`;
      }

      $(".price", ".product_modal").html(price_html);
    }
  };

  var change_pop_information = function (
    _section,
    _title,
    _dimensions,
    _bullet1,
    _bullet2,
    _bullet3,
    _bullet4,
    _bullet5,
    _bullet6,
    _bullet7,
    _bullet8,
    _bullet9,
    _bullet10,
    _doors,
    _drawers,
    _boxmaterial,
    _construction,
    _doorfinish,
    _numrollouttray,
    _numshelves,
    _carbiicompliant,
    _doormaterial,
    _drawerweightcapacity,
    _hudapproved,
    _warranty,
    _hinge,
    _price,
    _discountprice,
    _cabinetassembly,
  ) {
    $(".js-product-pop-title").html(`Model #${_title}`);
    $(".js-product-pop-section").html(_section);

    $(".js-product-pop-dimensions").html(_dimensions ?? "");

    var product_bullet_list = "";
    if (is_express) {
      product_bullet_list += `<li>Ships in 2 Business Days</li>`;
    }
    if ((_bullet1 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet1}</li>`;
    }
    if ((_bullet2 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet2}</li>`;
    }
    if ((_bullet3 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet3}</li>`;
    }
    if ((_bullet4 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet4}</li>`;
    }
    if ((_bullet5 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet5}</li>`;
    }
    if ((_bullet6 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet6}</li>`;
    }
    if ((_bullet7 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet7}</li>`;
    }
    if ((_bullet8 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet8}</li>`;
    }
    if ((_bullet9 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet9}</li>`;
    }
    if ((_bullet10 ?? "").length > 0) {
      product_bullet_list += `<li>${_bullet10}</li>`;
    }
    if (product_bullet_list.length > 0) {
      product_bullet_list = `<ul>${product_bullet_list}</ul>`;
    }
    $(".js-product-pop-bullet").html(product_bullet_list);

    var product_specifications_list = "";
    if ((_doors ?? "").length > 0) {
      product_specifications_list += `<li>Number Of Doors:&nbsp;<strong>${_doors}</strong></li>`;
    }
    if ((_drawers ?? "").length > 0) {
      product_specifications_list += `<li>Number Of Drawers:&nbsp;<strong>${_drawers}</strong></li>`;
    }
    if ((_numrollouttray ?? "").length > 0) {
      product_specifications_list += `<li>Number Of Roll Out Trays:&nbsp;<strong>${_numrollouttray}</strong></li>`;
    }
    if ((_numshelves ?? "").length > 0) {
      product_specifications_list += `<li>Number Of Shelves:&nbsp;<strong>${_numshelves}</strong></li>`;
    }
    if ((_cabinetassembly ?? "").length > 0) {
      product_specifications_list += `<li>Cabinet Assembly:&nbsp;<strong>${_cabinetassembly}</strong></li>`;
    }
    if ((_boxmaterial ?? "").length > 0) {
      product_specifications_list += `<li>Cabinet Material:&nbsp;<strong>${_boxmaterial}</strong></li>`;
    }
    if ((_construction ?? "").length > 0) {
      product_specifications_list += `<li>Cabinet Construction:&nbsp;<strong>${_construction}</strong></li>`;
    }
    if ((_doorfinish ?? "").length > 0) {
      product_specifications_list += `<li>Cabinet Finish:&nbsp;<strong>${_doorfinish}</strong></li>`;
    }
    if ((_carbiicompliant ?? "").length > 0) {
      product_specifications_list += `<li>CARB II Compliant:&nbsp;<strong>${_carbiicompliant}</strong></li>`;
    }
    if ((_doormaterial ?? "").length > 0) {
      product_specifications_list += `<li>Door Material:&nbsp;<strong>${_doormaterial}</strong></li>`;
    }
    if ((_drawerweightcapacity ?? "").length > 0) {
      product_specifications_list += `<li>Drawer Weight Capacity:&nbsp;<strong>${_drawerweightcapacity}</strong></li>`;
    }
    if ((_hudapproved ?? "").length > 0) {
      product_specifications_list += `<li>HUD Approved:&nbsp;<strong>${_hudapproved}</strong></li>`;
    }
    if ((_warranty ?? "").length > 0) {
      product_specifications_list += `<li>Warranty:&nbsp;<strong>${_warranty}</strong></li>`;
    }
    if (product_specifications_list.length > 0) {
      product_specifications_list = `<ul>${product_specifications_list}</ul>`;
    }
    $(".js-product-pop-specifications").html(product_specifications_list);

    $(".js-product-pop-hinge-value").html(_hinge);

    change_pop_price(_price, _discountprice);
  };

  $(".product-modal-wrap .js-product-pop-hinge-button").click(function (ev) {
    ev.stopPropagation();
    var $this = $(this);
    if ($this.hasClass("active")) return false;
    $this.siblings(".active").removeClass("active").end().addClass("active");

    /*   {% comment %} 
              $('.js-product-pop-carousel').hide();
              $('#carousel-product-model-'+$this.data('pid')).show();
      {% endcomment %} */
    var pid = $this.attr("data-pid");

    const selected_pop_button_depths =
      $this.html().indexOf("Left") > -1
        ? pop_depth_data.left
        : pop_depth_data.right;
    set_depth_dropdown(selected_pop_button_depths);
    //console.log(pop_depth_data);

    //console.log(pop_current_depth_data);

    //console.log(pop_product_images);
    var activeImages = pop_product_images.filter((i) => i.id == pid)[0].images;
    change_pop_imager_carousel(activeImages);

    const title = formatAttribute($this.attr("data-title"));
    const section = formatAttribute($this.attr("data-section"));
    const dimensions = formatAttribute($this.attr("data-dimensions"));

    const bullet1 = formatAttribute($this.attr("data-bullet1"));
    const bullet2 = formatAttribute($this.attr("data-bullet2"));
    const bullet3 = formatAttribute($this.attr("data-bullet3"));
    const bullet4 = formatAttribute($this.attr("data-bullet4"));
    const bullet5 = formatAttribute($this.attr("data-bullet5"));
    const bullet6 = formatAttribute($this.attr("data-bullet6"));
    const bullet7 = formatAttribute($this.attr("data-bullet7"));
    const bullet8 = formatAttribute($this.attr("data-bullet8"));
    const bullet9 = formatAttribute($this.attr("data-bullet9"));
    const bullet10 = formatAttribute($this.attr("data-bullet10"));

    const doors = $this.attr("data-doors");
    const drawers = $this.attr("data-drawers");
    const boxmaterial = formatAttribute($this.attr("data-boxmaterial"));
    const construction = formatAttribute($this.attr("data-construction"));
    const doorfinish = formatAttribute($this.attr("data-doorfinish"));
    const numrollouttray = formatAttribute($this.attr("data-numrollouttray"));
    const numshelves = formatAttribute($this.attr("data-numshelves"));

    const carbiicompliant = formatAttribute($this.attr("data-carbiicompliant"));
    const doormaterial = formatAttribute($this.attr("data-doormaterial"));
    const drawerweightcapacity = formatAttribute(
      $this.attr("data-drawerweightcapacity"),
    );
    const hudapproved = formatAttribute($this.attr("data-hudapproved"));
    const warranty = formatAttribute($this.attr("data-warranty"));
    const cabinetassembly = formatAttribute($this.attr("data-cabinetassembly"));

    const hinge = $this.html();

    let price = $this.attr("data-price");
    let discountprice = $this.attr("data-discountprice");

    //console.log(pop_current_depth_data);
    //console.log( $('.js-select-custom-depth','.product-modal-wrap').val());
    /*  {% comment %} if(pop_current_depth_data.filter(i=>i.depth == $('.js-select-custom-depth','.product-modal-wrap').val()).length > 0){
     let select_variant =  pop_current_depth_data.filter(i=>i.depth == $('.js-select-custom-depth','.product-modal-wrap').val())[0];
     price = select_variant.price;
     discountprice = select_variant.discount_price;
     //console.log(select_variant);
     var add_to_cart_button_attrs = $('.js-product-add-to-cart-button').data('obj').split(':');
     //productid:variantid:width:model:collection_handle:collection_shortname
     $('.js-product-add-to-cart-button').data('obj',`${pid}:${select_variant.id}:${add_to_cart_button_attrs[2]}:${add_to_cart_button_attrs[3]}:${add_to_cart_button_attrs[4]}:${add_to_cart_button_attrs[5]}`);
     }  {% endcomment %} */

    change_pop_information(
      section,
      title,
      dimensions,
      bullet1,
      bullet2,
      bullet3,
      bullet4,
      bullet5,
      bullet6,
      bullet7,
      bullet8,
      bullet9,
      bullet10,
      doors,
      drawers,
      boxmaterial,
      construction,
      doorfinish,
      numrollouttray,
      numshelves,
      carbiicompliant,
      doormaterial,
      drawerweightcapacity,
      hudapproved,
      warranty,
      hinge,
      price,
      discountprice,
      cabinetassembly,
    );

    return false;
  });

  var set_hinge_button_data = function (
    _button,
    _pid,
    _vid,
    _title,
    _section,
    _dimensions,
    _bullet1,
    _bullet2,
    _bullet3,
    _bullet4,
    _bullet5,
    _bullet6,
    _bullet7,
    _bullet8,
    _bullet9,
    _bullet10,
    _doors,
    _drawers,
    _boxmaterial,
    _construction,
    _doorfinish,
    _numrollouttray,
    _numshelves,
    _carbiicompliant,
    _doormaterial,
    _drawerweightcapacity,
    _hudapproved,
    _warranty,
    _width,
    _price,
    _discountprice,
    _product_handle,
  ) {
    _button.attr("data-pid", _pid);
    _button.attr("data-vid", _vid);
    _button.attr("data-title", _title);
    _button.attr("data-section", _section);
    _button.attr("data-dimensions", _dimensions);
    _button.attr("data-bullet1", _bullet1);
    _button.attr("data-bullet2", _bullet2);
    _button.attr("data-bullet3", _bullet3);
    _button.attr("data-bullet4", _bullet4);
    _button.attr("data-bullet5", _bullet5);
    _button.attr("data-bullet6", _bullet6);
    _button.attr("data-bullet7", _bullet7);
    _button.attr("data-bullet8", _bullet8);
    _button.attr("data-bullet9", _bullet9);
    _button.attr("data-bullet10", _bullet10);
    _button.attr("data-doors", _doors);
    _button.attr("data-drawers", _drawers);
    _button.attr("data-boxmaterial", _boxmaterial);
    _button.attr("data-construction", _construction);
    _button.attr("data-doorfinish", _doorfinish);
    _button.attr("data-numrollouttray", _numrollouttray);
    _button.attr("data-numshelves", _numshelves);
    _button.attr("data-carbiicompliant", _carbiicompliant);
    _button.attr("data-doormaterial", _doormaterial);
    _button.attr("data-drawerweightcapacity", _drawerweightcapacity);
    _button.attr("data-hudapproved", _hudapproved);
    _button.attr("data-warranty", _warranty);
    _button.attr("data-width", _width);
    _button.attr("data-price", _price);
    _button.attr("data-discountprice", _discountprice);
    _button.attr("data-producthandle", _product_handle);
  };

  var set_hige_button = function (_button, _button_data) {
    console.log(_button_data);
    var _pid = _button_data.pid,
      _vid = _button_data.vid,
      _title = _button_data.title,
      _section = _button_data.section,
      _dimensions = unFormatAttribute(
        getDimensions(
          formatAttribute(_button_data.actual_width),
          formatAttribute(_button_data.depth),
          formatAttribute(_button_data.height),
        ),
      ),
      _bullet1 = _button_data.bullet1,
      _bullet2 = _button_data.bullet2,
      _bullet3 = _button_data.bullet3,
      _bullet4 = _button_data.bullet4,
      _bullet5 = _button_data.bullet5,
      _bullet6 = _button_data.bullet6,
      _bullet7 = _button_data.bullet7,
      _bullet8 = _button_data.bullet8,
      _bullet9 = _button_data.bullet9,
      _bullet10 = _button_data.bullet10,
      _doors = _button_data.numdoors,
      _drawers = _button_data.numdrawers,
      _boxmaterial = _button_data.material,
      _construction = _button_data.construction,
      _doorfinish = _button_data.finish,
      _numrollouttray = _button_data.numrollouttray,
      _numshelves = _button_data.numshelves,
      _carbiicompliant = _button_data.carb_ii_compliant,
      _doormaterial = _button_data.door_material,
      _drawerweightcapacity = _button_data.drawer_weight_capacity,
      _hudapproved = _button_data.hud_approved,
      _warranty = _button_data.warranty,
      _width = _button_data.width,
      _price = _button_data.price,
      _discountprice = _button_data.discount_price,
      _product_handle = _button_data.product_handle;

    set_hinge_button_data(
      _button,
      _pid,
      _vid,
      _title,
      _section,
      _dimensions,
      _bullet1,
      _bullet2,
      _bullet3,
      _bullet4,
      _bullet5,
      _bullet6,
      _bullet7,
      _bullet8,
      _bullet9,
      _bullet10,
      _doors,
      _drawers,
      _boxmaterial,
      _construction,
      _doorfinish,
      _numrollouttray,
      _numshelves,
      _carbiicompliant,
      _doormaterial,
      _drawerweightcapacity,
      _hudapproved,
      _warranty,
      _width,
      _price,
      _discountprice,
      _product_handle,
    );
  };

  var set_depth_dropdown = function (depths) {
    let selected_depth = "";
    if ($("select.js-select-custom-depth", ".product-modal-wrap").length > 0) {
      selected_depth = $(
        "select.js-select-custom-depth",
        ".product-modal-wrap",
      ).val();
    }

    if (depths.length > 1) {
      depths.sort((a, b) => parseInt(a.depth) - parseInt(b.depth));

      let select_depth_obj = null;
      if (
        $("select.js-select-custom-depth", ".product-modal-wrap").length == 0
      ) {
        select_depth_obj = $('<select class="js-select-custom-depth" />');
        select_depth_obj.appendTo(
          $(".product-modal-wrap .div-select-customDepth"),
        );
      } else {
        select_depth_obj = $(
          "select.js-select-custom-depth",
          ".product-modal-wrap",
        );
      }

      add_depth_dropdown_event();
      let default_depth = depths.filter((i) => i.is_default_depth)[0];
      let select_value = default_depth.depth;
      if (depths.some((i) => i.depth == selected_depth)) {
        select_value = selected_depth;
      }

      let option_html = "";

      for (var i = 0; i < depths.length; i++) {
        let add_price = 0;
        let _depth = depths[i].depth;
        option_html += `<option value="${_depth}" ${_depth == select_value ? 'selected="selected"' : ""}>${_depth}" Depth [${default_depth.depth == depths[i].depth ? "Standard" : "Custom"}]&nbsp;${add_price >= 0 ? "+" : "-"}${Ideal.formatMoney(add_price, Ideal.money_format)}</option>`;
      }
      select_depth_obj.empty().append(option_html);
      $(".customDepth").show();
    } else {
      $(".customDepth select.js-select-custom-depth").remove();
      $(".customDepth").hide();
    }

    pop_current_depth_data = depths;
  };

  var add_depth_dropdown_event = function () {
    $(".js-select-custom-depth", ".product-modal-wrap")
      .off("change")
      .on("change", function () {
        /*  {% comment %} let select_variant = pop_current_depth_data.filter(i=>i.depth == $('.js-select-custom-depth','.product-modal-wrap').val())[0];         
       let price = select_variant.price;
       let discountprice = select_variant.discount_price;      
       change_pop_price(price, discountprice);                 {% endcomment %}   */
      });
  };

  $(".product-modal-wrap .width-items > a").click(function (ev) {
    ev.stopPropagation();
    var $this = $(this);
    if ($this.hasClass("active")) return false;
    $this.siblings("a").removeClass("active").end().addClass("active");
    var selectedWidth = $this.data("width");
    var selectOrDefaultHinge = "left";
    if (
      $(
        ".product-modal-wrap .div-select-hinge .js-product-pop-hinge-button.active",
      ).length > 0
    ) {
      selectOrDefaultHinge = $(
        ".product-modal-wrap .div-select-hinge .js-product-pop-hinge-button.active",
      )
        .data("hinge")
        .toLowerCase();
    }
    var filterData = pop_width_data.filter(
      (d) => d.hinge == selectOrDefaultHinge && d.width == selectedWidth,
    )[0];
    //console.log(pop_width_data);
    //console.log(filterData);

    change_pop_imager_carousel(filterData.images);
    set_depth_dropdown(filterData.depths);

    const otherFilterDatas = pop_width_data.filter(
      (d) =>
        d.hinge == (selectOrDefaultHinge == "left" ? "right" : "left") &&
        d.width == selectedWidth,
    );
    let otherHingeDepths = [];
    if (otherFilterDatas.length > 0) {
      otherHingeDepths = otherFilterDatas[0].depths;
    }

    if (selectOrDefaultHinge == "left") {
      pop_depth_data.left = filterData.depths;
      pop_depth_data.right = otherHingeDepths;
    } else {
      pop_depth_data.right = filterData.depths;
      pop_depth_data.left = otherHingeDepths;
    }

    //console.log(pop_width_data);
    //console.log(pop_depth_data);
    //console.log(pop_current_depth_data);

    const title = formatAttribute(filterData.title);
    const section = formatAttribute(filterData.section);
    const dimensions = getDimensions(
      formatAttribute(filterData.actual_width),
      formatAttribute(filterData.depth),
      formatAttribute(filterData.height),
    );

    const bullet1 = formatAttribute(filterData.bullet1);
    const bullet2 = formatAttribute(filterData.bullet2);
    const bullet3 = formatAttribute(filterData.bullet3);
    const bullet4 = formatAttribute(filterData.bullet4);
    const bullet5 = formatAttribute(filterData.bullet5);
    const bullet6 = formatAttribute(filterData.bullet6);
    const bullet7 = formatAttribute(filterData.bullet7);
    const bullet8 = formatAttribute(filterData.bullet8);
    const bullet9 = formatAttribute(filterData.bullet9);
    const bullet10 = formatAttribute(filterData.bullet10);

    const doors = formatAttribute(filterData.numdoors);
    const drawers = formatAttribute(filterData.numdrawers);
    const boxmaterial = formatAttribute(filterData.material);
    const construction = formatAttribute(filterData.construction);
    const doorfinish = formatAttribute(filterData.finish);
    const numrollouttray = formatAttribute(filterData.numrollouttray);
    const numshelves = formatAttribute(filterData.numshelves);

    const carbiicompliant = formatAttribute(filterData.carb_ii_compliant);
    const doormaterial = formatAttribute(filterData.door_material);
    const drawerweightcapacity = formatAttribute(
      filterData.drawer_weight_capacity,
    );
    const hudapproved = formatAttribute(filterData.hud_approved);
    const warranty = formatAttribute(filterData.warranty);

    const hinge =
      formatAttribute(filterData.hinge) == "left" ? "Left" : "Right";

    const cabinet_assembly = formatAttribute(filterData.cabinet_assembly);

    let price = filterData.price;
    let discountprice = filterData.discount_price;
    //if($('.js-select-custom-depth','.product-modal-wrap').length>0){
    //let select_depth =  filterData.depths.filter(i=>i.depth == $('.js-select-custom-depth','.product-modal-wrap').val())[0];
    //price = select_variant.price;
    //discountprice = select_variant.discount_price;
    //}

    change_pop_information(
      section,
      title,
      dimensions,
      bullet1,
      bullet2,
      bullet3,
      bullet4,
      bullet5,
      bullet6,
      bullet7,
      bullet8,
      bullet9,
      bullet10,
      doors,
      drawers,
      boxmaterial,
      construction,
      doorfinish,
      numrollouttray,
      numshelves,
      carbiicompliant,
      doormaterial,
      drawerweightcapacity,
      hudapproved,
      warranty,
      hinge,
      price,
      discountprice,
      cabinet_assembly,
    );

    if ($(".product-modal-wrap .hinge .div-select-hinge").length > 0) {
      pop_product_images = [];
      if (hinge === "Left") {
        var _button = $(".product-modal-wrap .hinge .div-select-hinge a:eq(0)");
        var _button_data = filterData;
        if (_button_data) {
          set_hige_button(_button, _button_data);
          pop_product_images.push({
            id: _button_data.pid,
            images: _button_data.images,
          });
        }

        _button = $(".product-modal-wrap .hinge .div-select-hinge a:eq(1)");
        _button_data = pop_width_data.filter(
          (d) => d.hinge == "right" && d.width == selectedWidth,
        )[0];
        if (_button_data) {
          set_hige_button(_button, _button_data);
          pop_product_images.push({
            id: _button_data.pid,
            images: _button_data.images,
          });
        }
      } else {
        var _button = $(".product-modal-wrap .hinge .div-select-hinge a:eq(1)");
        var _button_data = filterData;
        if (_button_data) {
          set_hige_button(_button, _button_data);
          pop_product_images.push({
            id: _button_data.pid,
            images: _button_data.images,
          });
        }

        _button = $(".product-modal-wrap .hinge .div-select-hinge a:eq(0)");
        _button_data = pop_width_data.filter(
          (d) => d.hinge == "left" && d.width == selectedWidth,
        )[0];
        if (_button_data) {
          set_hige_button(_button, _button_data);
          pop_product_images.push({
            id: _button_data.pid,
            images: _button_data.images,
          });
        }
      }

      var add_to_cart_button_attrs = $(".js-product-add-to-cart-button")
        .data("obj")
        .split(":");
      /*    {% comment %}  if($('.js-select-custom-depth','.product-modal-wrap').length>0){
             let select_variant =  filterData.depths.filter(i=>i.depth == $('.js-select-custom-depth','.product-modal-wrap').val())[0];
             $('.js-product-add-to-cart-button').data('obj',`${filterData.pid}:${filterData.vid}:${filterData.actual_width}:${filterData.model}:${add_to_cart_button_attrs[4]}:${add_to_cart_button_attrs[5]}`);
         }else{
             $('.js-product-add-to-cart-button').data('obj',`${filterData.pid}:${filterData.vid}:${filterData.actual_width}:${filterData.model}:${add_to_cart_button_attrs[4]}:${add_to_cart_button_attrs[5]}`);
         } {% endcomment %} */

      $(".js-product-add-to-cart-button").data(
        "obj",
        `${filterData.pid}:${filterData.vid}:${filterData.product_handle}:${filterData.actual_width}:${filterData.model}:${add_to_cart_button_attrs[5]}:${add_to_cart_button_attrs[6]}:${add_to_cart_button_attrs[7] ?? "false"}`,
      );
    } else {
      pop_product_images = [];
      pop_product_images.push({
        id: filterData.pid,
        images: filterData.images,
      });

      var add_to_cart_button_attrs = $(".js-product-add-to-cart-button")
        .data("obj")
        .split(":");
      /*  {% comment %} if($('.js-select-custom-depth','.product-modal-wrap').length>0){
           let select_variant =  filterData.variants.filter(i=>i.depth == $('.js-select-custom-depth','.product-modal-wrap').val())[0];
           $('.js-product-add-to-cart-button').data('obj',`${filterData.pid}:${select_variant.id}:${filterData.actual_width}:${filterData.model}:${add_to_cart_button_attrs[4]}:${add_to_cart_button_attrs[5]}`);
       }else{
           $('.js-product-add-to-cart-button').data('obj',`${filterData.pid}:${filterData.vid}:${filterData.actual_width}:${filterData.model}:${add_to_cart_button_attrs[4]}:${add_to_cart_button_attrs[5]}`);
           } {% endcomment %} */
    }
    $(".js-product-add-to-cart-button").data(
      "obj",
      `${filterData.pid}:${filterData.vid}:${filterData.product_handle}:${filterData.actual_width}:${filterData.model}:${add_to_cart_button_attrs[5]}:${add_to_cart_button_attrs[6]}:${add_to_cart_button_attrs[7] ?? "false"}`,
    );

    //console.log($('.js-product-add-to-cart-button').data('obj'));
  });

  $(".product-modal-wrap .js-product-add-to-cart-button").click(
    async function (ev) {
      ev.stopPropagation();
      var $this = $(this);
      var $warp = $this.closest(".product-modal-wrap");

      var add_to_cart_data = $this.data("obj");

      if ($warp.find(".js-product-pop-hinge-button.active").length > 0) {
        var arrs = add_to_cart_data.split(":");
        var activeHinge = $warp.find(".js-product-pop-hinge-button.active");
        add_to_cart_data =
          activeHinge.data("pid") +
          ":" +
          activeHinge.data("vid") +
          ":" +
          activeHinge.data("producthandle");
        for (var i = 3; i < arrs.length; i++) {
          add_to_cart_data += ":" + arrs[i];
        }

        //console.log(add_to_cart_data);
      }

      let selected_depth = "";
      let select_default_variant = 0;

      if ($(".js-select-custom-depth", ".product-modal-wrap").length > 0) {
        selected_depth = $(
          ".js-select-custom-depth",
          ".product-modal-wrap",
        ).val();
        /*  {% comment %}  
           if(pop_current_depth_data.filter(i=>i.depth == $('.js-select-custom-depth','.product-modal-wrap').val()).length > 0){
           let select_variant =  pop_current_depth_data.filter(i=>i.depth == $('.js-select-custom-depth','.product-modal-wrap').val())[0];         
           add_to_cart_data = add_to_cart_data.split(':');
           add_to_cart_data[1] = `${select_variant.id}`;   
           add_to_cart_data = add_to_cart_data.join(':');       
           }            
           {% endcomment %} */
      }

      //console.log(pop_current_depth_data);
      //alert(add_to_cart_data);
      $this.data("obj", add_to_cart_data);

      //console.log(pop_width_data);
      //console.log(add_to_cart_data);
      //return;

      $(".product-modal-wrap").hide();
      $(".product-modal-wrap").prev().hide();
      await AddToCart(
        $this,
        function () {
          $(".product-modal-wrap").modal("hide");
        },
        function () {
          $(".product-modal-wrap").show();
          $(".product-modal-wrap").prev().show();
        },
        selected_depth ?? "",
        "product_pop_up_detail",
      );

      return false;
    },
  );

  $(".product-modal-wrap .carousel")
    .hammer()
    .on("swipeleft", function () {
      $(this).carousel("next");
    });
  $(".product-modal-wrap .carousel")
    .hammer()
    .on("swiperight", function () {
      $(this).carousel("prev");
    });

  add_depth_dropdown_event();
}

const ProductFormAddToCartExtension = ($this, evt, status) => {
  evt.preventDefault();
  const add_to_cart_button = $($this.addToCart);
  //console.log(add_to_cart_button);
  console.log(add_to_cart_button.data("obj"));
  AddToCart(add_to_cart_button);
};
